import { Pipe, PipeTransform } from '@angular/core';
import { ExportHelper } from '../../../../services/helpers/export-helper';

/**
 * Renders stored rich-text as a one-line plain-text preview.
 *
 * Pure, so the (DOM-parsing) conversion runs once per distinct input value rather than on
 * every change-detection pass for every row — which is what calling the helper straight from
 * a template binding costs in a table.
 *
 * Deliberately not the existing `htmlSanitizer` pipe: `stripHtmlToPlainText` also guards
 * legacy plain-text values that merely contain literal '<'/'>' from being parsed as markup,
 * and substitutes a placeholder for images. Swapping one for the other would silently change
 * both behaviours.
 */
@Pipe({
  name: 'stripHtml',
  standalone: true,
})
export class StripHtmlPipe implements PipeTransform {
  constructor(private exportHelper: ExportHelper) {}

  transform(html: string | null | undefined, imagePlaceholder: string = '[image]'): string {
    return this.exportHelper.stripHtmlToPlainText(html, imagePlaceholder);
  }
}
